import React from 'react';
import { Link } from 'react-router-dom';
import { StarRating } from './StarRating';

export const InstructorCard = ({ instructor = {} }) => {
    const safeInstructor = instructor || {};
    // ── Data Mapping (Support both Mock and Real API data) ──
    const name = safeInstructor.full_name || safeInstructor.name || 'Instructor';
    const image = instructor.profile_picture || instructor.image || 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=150&h=150&fit=crop';
    const id = instructor._id || instructor.id;
    
    // Role logic: use experience or provided role
    const role = safeInstructor.experience !== undefined 
        ? `${safeInstructor.experience} Years Experience` 
        : safeInstructor.role || 'Expert Mentor';

    const rating = parseFloat(safeInstructor.average_rating || safeInstructor.rating || 5);
    const students = safeInstructor.students || Math.floor(Math.random() * 500) + 50;

    return (
        <Link to={`/teachers/${id}`} className="text-decoration-none h-100 d-block">
            <div className="bg-white border h-100 overflow-hidden shadow-sm hover-shadow transition-all card-mentor">
                <img 
                    src={image} 
                    alt={name} 
                    className="img-fluid w-100 object-fit-cover" 
                    style={{ height: "170px" }} 
                    onError={(e) => { e.target.src = 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=150&h=150&fit=crop'; }}
                />
                <div className="item-info">
                    <div className="text-center p-3">
                        <div className="instructor-name fs-6 fw-semibold text-gray-900 mb-1 text-truncate d-flex align-items-center justify-content-center gap-1" title={name}>
                            {name}
                            {safeInstructor.is_blue_verified && <i className="bi bi-patch-check-fill text-primary" style={{ fontSize: '0.85rem' }} title="Verified Teacher" />}
                        </div>
                        <div className="instructor-role small text-gray-500 text-truncate">
                            {role}
                        </div>
                    </div>

                    <div className="border-top d-flex flex-wrap align-items-center justify-content-between gap-2 small text-body px-3 py-2 bg-light bg-opacity-50">
                        <span className="ratings d-flex align-items-center gap-1">
                            <StarRating rating={rating} />
                            <span className="rating-number fw-medium">{rating.toFixed(1)}</span>
                        </span>
                        <span>{students} <span className="fw-normal text-gray-500">students</span></span>
                    </div>
                </div>
            </div>
        </Link>
    );
};
